// Bal Kovanı teması — küçük etkileşimler
(function () {
  // Mobil menü
  var toggle = document.getElementById('MenuToggle')
  var nav = document.getElementById('SiteNav')
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open')
    })
  }

  // Scroll reveal — bölümler kaydırdıkça yumuşakça belirir
  var revealEls = document.querySelectorAll('.reveal')
  if ('IntersectionObserver' in window && revealEls.length) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.12 }
    )
    revealEls.forEach(function (el) { observer.observe(el) })
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible') })
  }

  // Ürün sayfasında varyant değişince fiyatı güncelle
  var variantSelect = document.getElementById('VariantSelect')
  var priceEl = document.getElementById('ProductPrice')
  if (variantSelect && priceEl) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex]
      if (opt && opt.dataset.price) priceEl.textContent = opt.dataset.price
    })
  }
})()
